import { ReactElement } from "react";
import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { IsAgentTypingProps } from "../../definitions";

import { copy } from "../../definitions";

const AgentTyping = ({
  agent,
  isTyping,
  participantFriendlyNames,
}: IsAgentTypingProps): ReactElement => {
  const agentKey = agent.identity || "";
  const agentName = participantFriendlyNames[agentKey] || "Agent";

  if (isTyping) {
    return (
      <Box padding="space80">
        <Text as="p" color="colorTextWeak">
          {copy.isTyping(agentName)}
        </Text>
      </Box>
    );
  }

  return <></>;
};

export default AgentTyping;
